import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Tabs from "@common/components/tabs";
import { useTranslation } from "@common/hooks/translation";

import { SearchTabTypes, searchTabs } from "../constants";
import NumericInput from "@common/components/numericInput";
import KeyboardInput from "@common/components/InputKeyboard";
import { getPlayerInfo } from "@app/dev/helpers/clientTransaction";
import ToastWrapper from "@common/helpers/toastWrapper";

const ClientTransactionSearchPlayer = ({ title, description, onNext }) => {
  const t = useTranslation();
  const [tab, setTab] = useState(SearchTabTypes.PLAYER_ID);
  const [value, setValue] = useState("");

  const changeTab = (option) => {
    setTab(option.value);
    setValue("");
  };

  const onSearch = async () => {
    const data = tab === SearchTabTypes.PLAYER_ID ? { id: value } : { login: value };

    const result = await getPlayerInfo(data);

    if (result?.playerInfo) onNext?.(result);
    else ToastWrapper("error", "Player not found");
  };

  return (
    <div className="ct-form">
      <h3 className="ct-form-title">{t(title)}</h3>
      <p className="ct-form-subtitle">{t(description)}</p>

      <Tabs value={tab} onChange={changeTab} options={searchTabs} />

      <div className="ct-input-wrapper">
        {tab === SearchTabTypes.PLAYER_ID ? (
          <NumericInput value={value} onChange={setValue} placeholder={t("Player id")} />
        ) : (
          <KeyboardInput type="text" placeholder={t("Username")} disableSearchIcon onChange={setValue} />
        )}
      </div>

      <div className="ct-form-buttons">
        <Link to="/clientTransaction">{t("Back")}</Link>
        <button className="ct-form-submit-btn" onClick={onSearch}>
          {t("Search")}
        </button>
      </div>
    </div>
  );
};

ClientTransactionSearchPlayer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onNext: PropTypes.func,
};

export default ClientTransactionSearchPlayer;
